export default "__VITE_ASSET__YZth7Bz4__"